import { Component, EventEmitter, OnInit, Input, Output, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MaskType } from 'src/app/constants/masks';
import { USStates } from 'src/app/constants/us-states';
import { USAePay, USAePayPayload } from 'src/app/models/USAePay';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { HelperService } from 'src/app/services/helper.service';

@Component({
    selector: 'mwp-usa-e-pay-form',
    templateUrl: './usa-e-pay-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class USAePayFormComponent implements OnInit, AfterContentChecked {
    @Input() public usaEPay: USAePay;
    @Input() public isWizardForm: boolean;

    @Output() public emitContinue: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<USAePayPayload> = new EventEmitter();

    public maskType = MaskType;
    public usStates = USStates;
    public ePayForm: FormGroup;
    public cardInfo: string;
    public isTestPayServerDisabled: boolean;
    private currentUsaEPay: USAePay;

    constructor(
        private helperService: HelperService,
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    ngAfterContentChecked(): void {
        if (this.currentUsaEPay != this.usaEPay) {
            this.buildForm();
        }
    }

    private buildForm(): void {
        if (!this.usaEPay)
            this.usaEPay = new USAePay();

        this.currentUsaEPay = this.usaEPay;
        this.ePayForm = this.formBuilder.group({
            firstName: [this.usaEPay.firstName, Validators.required],
            lastName: [this.usaEPay.lastName, Validators.required],
            homeAddressLine1: [this.usaEPay.homeAddressLine1, Validators.required],
            homeAddressLine2: [this.usaEPay.homeAddressLine2,],
            homeCity: [this.usaEPay.homeCity, Validators.required],
            homeState: [this.usaEPay.homeState, Validators.required],
            homeZipCode: [this.usaEPay.homeZipCode, [Validators.required, Validators.compose([FormValidationService.validZipcode(true)])]],
            homeEmail: [this.usaEPay.homeEmail, Validators.compose([FormValidationService.validEmail(false)])],
            cardNumber: [null, Validators.required],
            cardExpiration: [null, [Validators.required, Validators.compose([FormValidationService.validShortDateCCExpire(true)])]],
            sendReceipt: [false]
        });
        this.cardInfo = this.usaEPay.existingCardInformation;
        this.isTestPayServerDisabled = this.usaEPay.isTestPayServerDeactivated;
    }

    public complete(): void {
        const l_USAePayPayload: USAePayPayload = this.helperService.convertFormGroupIntoObject(this.ePayForm, new USAePayPayload());
        if(this.isWizardForm)
            this.emitContinue.emit(l_USAePayPayload);
        else
            this.emitSave.emit(l_USAePayPayload);
    }

    public requireEmail(event: MatCheckboxChange): void {
        const l_EmailControl = this.ePayForm.get('homeEmail');

        l_EmailControl.clearValidators();
        if (event.checked) {
            l_EmailControl.setValidators([Validators.required, Validators.compose([FormValidationService.validEmail(true)])]);
        } else {
            l_EmailControl.setValidators(Validators.compose([FormValidationService.validEmail(false)]));
        }

        l_EmailControl.updateValueAndValidity();
    }
}